export const GET_STARTED_PATH = "/get-started";

export const siteNavLinks = [
  { to: "/how-it-works", label: "How it works" },
  { to: "/faq", label: "FAQs" },
  { to: "/about", label: "About" },
];
